import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { capturePayPalPayment } from '../../api/api';
import Notification from '../../components/notification';
import './PaymentSuccess.css';
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/sign-in');
      return;
    }

    const handlePaymentSuccess = async () => {
      try {
        const orderId = searchParams.get('token'); // PayPal returns the order ID as 'token'
        if (!orderId) {
          throw new Error('No order ID found');
        }

        // Capture the payment
        const response = await capturePayPalPayment(orderId);
        
        if (response.data.success) {
          setNotification({
            type: 'success',
            message: 'Payment successful! Your subscription has been activated.'
          });
          
          // Redirect to packages page after 3 seconds
          setTimeout(() => {
            navigate('/packages');
          }, 3000);
        } else {
          throw new Error('Payment capture failed');
        }
      } catch (error) {
        console.error('Payment processing error:', error);
        setNotification({
          type: 'error',
          message: 'Failed to process payment. Please contact support.'
        });
      }
    };

    handlePaymentSuccess();
  }, [navigate, searchParams]);

  return (
    <div className="payment-success-container">
      <h1>Processing Your Payment</h1>
      <p>Please wait while we confirm your payment...</p>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default PaymentSuccess; 